module.exports = __webpack_public_path__ + "img/BBD.a583ec1b.svg";